import classes from './loading.module.css'

const Loading = () => {
    return (
        <div className={classes.ldsEllipsis}><div></div><div></div><div></div><div></div></div>
    );
}

export { Loading };